import { Route, Routes as RouterRoutes } from 'react-router';

import { UserContainer } from './user_container';
import { UserListContainer } from './user_list_container';
import { Routes } from '../../routes';

export const UsersContainer = () => (
  <RouterRoutes>
    <Route path={Routes.User.relativePath} element={<UserContainer />} />
    <Route index element={<UserListContainer />} />
  </RouterRoutes>
);
